import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=17de015a&scoped=true&"
import script from "./commodity.vue?vue&type=script&lang=js&"
export * from "./commodity.vue?vue&type=script&lang=js&"
import style0 from "./commodity.vue?vue&type=style&index=0&id=17de015a&scoped=true&lang=css&"
import style1 from "./commodity.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17de015a",
  null
  
)

export default component.exports